<!-- TODO - FOR REFACTORING
1. Use Province, City/Municipality, Barangay dropdown selectors. See AddEditBillingContact.vue for example 
2. reate component to be shared in MyProfile and UserProfile -->

<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <!--navigate back to previous since sometimes this page is access from other pages, not HR > Employees page -->
                    <v-btn icon dark title="Back to employee list" @click="$router.go(-1)"> 
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-chip v-if="!loading" @click="view201Files" outline title="Click to view 201 files of this employee">
                        <v-icon color="#F9A825">folder</v-icon>&nbsp;&nbsp;<span class="header-files white--text">201 Files</span>
                    </v-chip>
                    <v-chip v-if="!loading&&isResignedOrTerminated&&hasEditRights&&isActiveAccount" @click="showDeactivateConfirmation" outline title="Click to deactivate this employee account">
                        <v-icon color="red">person_off</v-icon>&nbsp;&nbsp;<span class="header-files white--text">Deactivate</span>
                    </v-chip>
                    <v-chip v-if="!isActiveAccount&&!isMobile" outline>
                        <v-icon color="grey">person_off</v-icon>&nbsp;&nbsp;<span class="white--text">Deactivated on {{deactivatedOn}}</span>
                    </v-chip>
                    <help-link appId="company" pageId="user-profile" color="white"></help-link>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support. Error details: {{errorMessage}}
            </v-alert>

            <v-expansion-panel v-model="panel" expand v-if="!loading&&employment_info">
                <!-- EMPLOYEE DETAILS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-4px;':''">PERSONAL DETAILS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-toolbar class="transparent" flat height="25">
                            <v-spacer></v-spacer>
                            <v-btn v-if="hasEditRights&&isActiveAccount" icon title="Edit Employee Details" @click="showEditMember">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text v-if="!loading">
                            <v-chip v-if="!isActiveAccount&&isMobile" outline style="margin-top:-30px;">
                                <v-icon color="red">person_off</v-icon>&nbsp;&nbsp;<span class="red--text">Deactivated on {{deactivatedOn}}</span>
                            </v-chip>
                            <personal-details :basic_info="basic_info" :address_info="address_info"></personal-details>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- TEAM MEMBERSHIPS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-4px;':''">TEAM MEMBERSHIPS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1">
                        <v-toolbar class="transparent" flat height="25">
                            <v-spacer></v-spacer>
                            <v-btn icon v-if="hasEditRights&&isActiveAccount" title="Add Team Membership" @click="showAddTeamMembership">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text v-if="!loading">
                            <v-card class="elevation-1">
                                <v-data-table
                                    :headers="isMobile ? [] : headers"
                                    :items="team_membership"
                                    :loading="loading"
                                    :hide-headers="isMobile"
                                >  
                                    <template v-slot:items="props">

                                        <!-- mobile view -->
                                        <tr v-if="isMobile">
                                            <td :colspan="headers.length" class="pa-1">
                                                <v-card class="elevation-1">
                                                    <v-toolbar flat height="42">
                                                        <v-chip small class="user-chip-container">
                                                            <b>{{ props.item.team }}</b>
                                                        </v-chip>
                                                        <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                    <v-layout row wrap align-center class="section-layout">
                                                        <v-flex xs12 class="text-xs-left mt-5">
                                                            <v-layout row>
                                                                <v-flex xs4>
                                                                    <div class="caption grey--text text--darken-1">Role</div>
                                                                    <div>{{ props.item.role }}</div>
                                                                </v-flex>
                                                                <v-flex xs8>
                                                                    <div class="caption grey--text text--darken-1">Supervisor</div>
                                                                    <v-chip v-if="props.item.supervisor.userId" class="user-chip-container" small>
                                                                        <v-avatar>
                                                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.supervisor.userId)"></v-img>
                                                                        </v-avatar>
                                                                        {{props.item.supervisor.firstName}} {{props.item.supervisor.lastName}}
                                                                    </v-chip>
                                                                </v-flex>
                                                            </v-layout>
                                                             <v-layout row>
                                                                <v-flex xs12>
                                                                    <div class="caption grey--text text--darken-1">Visible In My Teams</div>
                                                                    <div v-if="props.item.visibleInMyTeams">Yes</div>
                                                                    <div v-else>No</div>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn v-if="hasEditRights&&isActiveAccount" icon @click="editAssignment(props.item)">
                                                            <v-icon small>edit</v-icon>
                                                        </v-btn>
                                                        <v-btn v-if="canDeleteTeamMembership&&hasEditRights&&isActiveAccount" icon @click="showDelete(props.item)">
                                                            <v-icon small>delete</v-icon>
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </td>
                                        </tr>

                                        <!-- desktop view -->
                                        <tr v-else @click="editAssignment(props.item)" title="Click to edit" :style="hasEditRights&&isActiveAccount?'cursor:pointer':''">
                                            <td>{{ props.item.team }}</td>
                                            <td>{{ props.item.role }}</td>
                                            <td>
                                                <v-chip v-if="props.item.supervisor.userId" class="user-chip-container" small>
                                                    <v-avatar>
                                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.supervisor.userId)"></v-img>
                                                    </v-avatar>
                                                    {{props.item.supervisor.firstName}} {{props.item.supervisor.lastName}}
                                                </v-chip>
                                            </td>
                                            <td>
                                                <span v-if="props.item.visibleInMyTeams">Yes</span>
                                                <span v-else>No</span>
                                            </td>
                                            <td @click.stop>
                                                <v-btn v-if="canDeleteTeamMembership&&hasEditRights&&isActiveAccount" icon title="Delete membership" @click="showDelete(props.item)">
                                                    <v-icon small>delete</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table> 
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- EMPLOYMENT DETAILS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold  primary--text" :style="isMobile?'margin-left:-4px;':''">EMPLOYMENT</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-toolbar class="transparent" flat height="25">
                            <v-spacer></v-spacer>
                            <v-btn icon v-if="hasEditRights&&isActiveAccount" title="Edit Employment" @click="showEditEmployment">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text v-if="!loading&&employment_info">
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Employment Status : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            <span :class="commonfn.getStatusColor(employment_info.employmentStatus)">{{commonfn.getStatusDescription(employment_info.employmentStatus)}}</span>
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Employment Type :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{commonfn.getStatusDescription(employment_info.employmentType)}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Position :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{employment_info.position}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Start Date : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{employment_info.startDate|moment('MMM DD, YYYY')}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout v-if="isResignedOrTerminated" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Last working date : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{employment_info.endDate|moment('MMM DD, YYYY')}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Salary Type :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            <span v-if="employment_info.salaryType">{{commonfn.getSalaryTypeName(employment_info.salaryType)}}</span>
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            TIN :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{formattedTIN}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            SSS :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{formattedSSS}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Pagibig :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{formattedPagibig}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Philhealth :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{formattedPhilhealth}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- BANK DETAILS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-4px;':''">BANK DETAILS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-toolbar class="transparent" flat height="25">
                            <v-spacer></v-spacer>
                            <v-btn icon v-if="isActiveAccount&&(canAddBankAccount||canEditBankAccount)" title="Edit Bank Details" @click="showEditBankDetails">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text v-if="!loading&&employment_info">
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Bank : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{bank_account?bank_account.bankName:'Not Updated'}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Branch : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{bank_account?bank_account.bankBranch:'Not Updated'}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Bank Account : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{bank_account?bank_account.bankAccount:'Not Updated'}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedUserId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogUpdate" persistent width="700">
            <update-member ref="updateMemberDialog" :dialogUpdate.sync="dialogUpdate" @send="getEmployee(false)"></update-member>
        </v-dialog>
        <v-dialog v-model="dialogUpdateTeamMembership" persistent width="750" >
            <team-membership ref="refUpdateTeamMembership" :dialogUpdateTeamMembership.sync="dialogUpdateTeamMembership" @send="getEmployee(false)"></team-membership>
        </v-dialog>
        <v-dialog v-model="dialogEmployment" persistent width="650">
            <update-employment ref="refEmployment" :dialogEmployment.sync="dialogEmployment" @send="getEmployee(false)"></update-employment>
        </v-dialog>
        <v-dialog v-model="dialogUpdateBank" persistent width="500" >
            <update-bank ref="refBank" :dialogUpdateBank.sync="dialogUpdateBank" @send="getEmployee(false)"></update-bank>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteTeamAssignment"></delete>
        </v-dialog>
        <v-dialog v-model="dialogOkCancel" persistent width="600">
            <ok-cancel :msg="dialogOkCancelMsg" alignLeft="true" title="Deactivate Employee Account" :dialogOkCancel.sync="dialogOkCancel" @ok="deactiveUser"></ok-cancel>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedUserId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>
<script>

import commonfn from '@/common/functions'       //for refactor
import employeeApi from '@/api/employees'
import userApi from '@/api/user'
import teamApi from '@/api/team'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import { hasAddRights, hasEditRights } from '@/helpers/access-permissions'

export default {  
    name: 'UserProfile',
    metaInfo: {
        title: 'User Profile',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View my other team member profile' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'personal-details': () => import('@/components/201Files/PersonalDetails'),
        'team-membership': () => import("@/components/ManageTeam/UpdateTeamMembership"),
        'update-employment': () => import("@/components/ManageTeam/EditEmployment"),
        'update-member': () => import("@/components/ManageTeam/UpdateMember"),
        'update-bank': () => import("@/components/ManageTeam/UpdateBankDetails"),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
    },
    data () {
        return {
            commonfn,
            awsS3Helper,
            disabled: false,
            loading: false,
            loading_delete: false,
            error: false,
            errorMessage: '',
            dialogDelete: false,
            dialogOkCancel: false,
            dialogOkCancelMsg: null,
            headers: [
                {text:'Team', align: 'left',value:'team', width:'25%', sortable:false},
                {text:'Role', align: 'left',value:'role', width:'25%', sortable:false},
                {text:'Supervisor', align: 'left',value:'supervisor', width:'25%', sortable:false},
                {text:'Visible In My Teams', align: 'left',value:'visibleInMyTeams', width:'25%', sortable:false},
                {text:'Delete', align: 'left',value:'', width:'5%', sortable:false},                    
            ], 
            message: null,
            basic_info: null,
            address_info: null,
            employment_info: null,
            team_membership: [],
            bank_account: null,
            user_settings: null,
            panel: [true],
            dialogUpdate: false,
            dialogUpdateTeamMembership: false,
            dialogEmployment: false,
            dialogUpdateBank: false,
            teamMemberId: null
        }
    },
    methods: {
        showDeactivateConfirmation() {
            this.dialogOkCancelMsg = `Deactivating this account will:<br><br>
                                        <ul>
                                            <li>Make employee details and HR 201 files read-only</li>
                                            <li>Disable payroll and annualization (existing records stay viewable)</li>
                                            <li>Exclude the employee from billing</li>
                                            <li>Prevent any future reactivation</li>
                                        </ul>
                                        <br>
                                        <b>Proceed with deactivation?</b>`
            this.dialogOkCancel = true
        },
        async deactiveUser() {
            try {
                await userApi.deactivate(this.selectedUserId)
                await this.getEmployee(true)
                this.dialogOkCancel = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        view201Files() {
            this.$router.push(`/hr/201/${this.selectedUserId}/files`)
        },
        showDelete(data) {
            this.teamMemberId = data.teamMemberId
            this.$refs.refDeleteComponent.setMessage("Delete this team assignment?")
            this.dialogDelete = true
        },
        async deleteTeamAssignment() {
            try {
                this.loading_delete = true
                const response = await teamApi.deleteMembership(this.teamMemberId)
                if (response && response.status == 200) {
                    this.dialogDelete = false
                    await this.getEmployee(false)
                }
                this.loading_delete = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        editAssignment(editData) {
            if (this.isActiveAccount && this.hasEditRights) {
                var data = {
                    mode: 'Update',
                    userId: this.selectedUserId,
                    roleId: editData.roleId,
                    teamId: editData.teamId,
                    supervisorId: editData.supervisor.userId,
                    visibleInMyTeams: editData.visibleInMyTeams
                }
                this.$refs.refUpdateTeamMembership.setParams(data)
                this.dialogUpdateTeamMembership = true
            }
        },
        showEditBankDetails() {
            var data = {
                userId: this.selectedUserId,
                bankDetails: this.bank_account
            }
            this.$refs.refBank.setParams(data)
            this.dialogUpdateBank = true
        },
        showEditMember() {
            this.$refs.updateMemberDialog.setParamsEdit(this.basic_info, this.address_info)
            this.dialogUpdate=true
        },
        showEditEmployment() {
            this.$refs.refEmployment.setParams(true, this.basic_info, this.employment_info)
            this.dialogEmployment = true
        },
        showAddTeamMembership(){
            var data = {
                mode: 'Add',
                userId: this.basic_info.userId,
                membership: this.team_membership
            }
            this.$refs.refUpdateTeamMembership.setParams(data)
            this.dialogUpdateTeamMembership = true
        },
        async getEmployee(show_loading) {
            try{
                this.loading = show_loading
                const response = await employeeApi.get(this.selectedUserId)
                if (response && response.status == 200) {
                    this.basic_info = response.data.basicInfo
                    this.address_info = response.data.address
                    this.employment_info = response.data.employment
                    this.team_membership = response.data.teamMembership
                    this.bank_account = response.data.bankAccount
                    this.user_settings = response.data.userSettings
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        await this.getEmployee(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.basic_info.firstName} ${this.basic_info.lastName}`,
            avatarPath: awsS3Helper.getProfileAvatarUrl(this.basic_info.userId)
        })
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        canAddBankAccount() {
            return !this.bank_account && this.hasAddRights
        },
        canEditBankAccount() {
            return this.bank_account && this.hasEditRights
        },
        selectedUserId() {
            return this.$route.params.userId
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.selectedUserId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.employees,
                    notificationTypeId: notificationTypes.myprofile
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },        
        formattedTIN() {
            if (this.employment_info.tin)
                return `${this.employment_info.tin.substring(0,3)}-${this.employment_info.tin.substring(3,6)}-${this.employment_info.tin.substring(6,9)}`
        },
        formattedSSS() {
            if (this.employment_info.sss)
                return `${this.employment_info.sss.substring(0,2)}-${this.employment_info.sss.substring(2,9)}-${this.employment_info.sss.substring(9,10)}`
        },
        formattedPagibig() {
            if (this.employment_info.pagibig)
                return `${this.employment_info.pagibig.substring(0,4)}-${this.employment_info.pagibig.substring(4,8)}-${this.employment_info.pagibig.substring(8,12)}`
        },
        formattedPhilhealth() {
            if (this.employment_info.philhealth)
                return `${this.employment_info.philhealth.substring(0,2)}-${this.employment_info.philhealth.substring(2,11)}-${this.employment_info.philhealth.substring(11,12)}`
        },
        isResignedOrTerminated() {
            return this.employment_info.employmentStatus==commonfn.getStatusCode('Resigned') ||
                    this.employment_info.employmentStatus==commonfn.getStatusCode('Terminated')
        },
        isActiveAccount() {
            return !this.basic_info.deactivated
        },
        deactivatedOn() {
            if (this.basic_info.deactivatedOn)
                return this.$moment(this.basic_info.deactivatedOn).format('MMM DD, YYYY')
        },
        canDeleteTeamMembership() {
            return this.team_membership.length > 1
        }
    },
}
</script>
<style scoped>
    .section-layout {
        padding:0px 20px 0px 50px;
    }
    .section-layout-mobile {
        padding:0px 10px 0px 10px;
    }
    .header-files {
        cursor: pointer;
    }
    .header-files:hover {
        text-decoration: underline;
    }
</style>